import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { Button, ButtonGroup, Chip } from '@mui/material';
import StatusDialog from './StatusDialog';
import { useState } from 'react';
import { VscEye } from 'react-icons/vsc';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

// const rows = [
//   { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
//   { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
//   { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
//   { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
//   { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
//   { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
//   { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
//   { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
//   { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 }
// ];

// const paginationModel = { page: 0, pageSize: 5 };

export default function AgentTable(props) {
  const [OpenStatus, setOpenStatus] = useState(false);
  const [UserIdData, setUserIdData] = useState('');
  const UserList = props?.UserList;

  const handleStatusOpen = (value) => {
    setUserIdData(value.user_id);
    setOpenStatus(true);
  };

  const handleStatusClose = () => {
    setOpenStatus(false);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const rows =
    UserList && Array.isArray(UserList)
      ? UserList.map((item) => ({
          user_id: item.user_id,
          aadhaar_name: item.aadhaar_name ? item.aadhaar_name : '-',
          user_code: item.user_code ? item.user_code : '-',
          organization_name: item.organization_name ? item.organization_name : '-',
          home_district: item.home_district ? item.home_district : '-',
          home_state: item.home_state ? item.home_state : '-',
          activation_date: item.activation_date ? formatDate(item.activation_date) : '-',
          distributor_class: item.distributor_class ? item.distributor_class : '-',
          distributor_services_type: item.distributor_services_type ? item.distributor_services_type : '-',
          dob: item.dob ? item.dob : '-',
          email_address: item.email_address ? item.email_address : '-',
          category: item.category ? item.category : '-',
          father_name: item.father_name ? item.father_name : '-',
          first_name: item.first_name ? item.first_name : '-',
          gender: item.gender ? item.gender : '-',
          home_address: item.home_address ? item.home_address : '-',
          home_landmark: item.home_landmark ? item.home_landmark : '-',
          home_city_village: item.home_city_village ? item.home_city_village : '-',
          qualification: item.qualification ? item.qualification : '-',
          home_pincode: item.home_pincode ? item.home_pincode : '-',
          home_region: item.home_region ? item.home_region : '-',
          retail_address: item.retail_address ? item.retail_address : '-',
          home_sub_district: item.home_sub_district ? item.home_sub_district : '-',
          last_name: item.last_name ? item.last_name : '-',
          retail_city_village: item.retail_city_village ? item.retail_city_village : '-',
          retail_district: item.retail_district ? item.retail_district : '-',
          retail_pincode: item.retail_pincode ? item.retail_pincode : '-',
          retail_state: item.retail_state ? item.retail_state : '-',
          retail_sub_district: item.retail_sub_district ? item.retail_sub_district : '-',
          savings_account_holder_name: item.savings_account_holder_name ? item.savings_account_holder_name : '-',
          savings_account_ifsc_code: item.savings_account_ifsc_code ? item.savings_account_ifsc_code : '-',
          savings_account_number: item.savings_account_number ? item.savings_account_number : '-',
          savings_bank_name: item.savings_bank_name ? item.savings_bank_name : '-',
          mobile_number: item.mobile_number ? item.mobile_number : '-',
          distributor_type: item.distributor_type ? item.distributor_type : '-',
          longitude: item.longitude ? item.longitude : '-',
          latitude: item.latitude ? item.latitude : '-',
          distributor_status: item.distributor_status ? item.distributor_status : '-',
          marksheet_10th_12th: item.marksheet_10th_12th ? item.marksheet_10th_12th : '-',
          Address_proof: item.Address_proof ? item.Address_proof : '-',
          aadharcard_file: item.aadharcard_file ? item.aadharcard_file : '-',
          cir_report: item.cir_report ? item.cir_report : '-',
          gst_certificate: item.gst_certificate ? item.gst_certificate : '-',
          graduation_certificate: item.graduation_certificate ? item.graduation_certificate : '-',
          pancard_file: item.pancard_file ? item.pancard_file : '-',
          statement_saving: item.statement_saving ? item.statement_saving : '-',
          statement_od_ca: item.statement_od_ca ? item.statement_od_ca : '-'
        }))
      : [];

  const columns = [
    // { field: 'id', headerName: 'S.No', width: 70 },
    { field: 'aadhaar_name', headerName: 'DS Name', width: 150 },
    { field: 'user_code', headerName: 'DS Code', width: 100 },
    {
      field: 'organization_name',
      headerName: 'DS Organization Name',
      type: 'number',
      width: 170,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'home_district',
      headerName: 'District',
      sortable: false,
      width: 120,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'home_state',
      headerName: 'State',
      sortable: false,
      width: 120,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'activation_date',
      headerName: 'Activation Date',
      sortable: false,
      width: 120,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'mobile_number',
      headerName: 'Mobile number',
      sortable: false,
      width: 110,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'distributor_status',
      headerName: 'Status',
      sortable: false,
      width: 130,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={
            params.value === 'Active'
              ? 'success'
              : params.value === 'Inactive' || params.value === 'Dormant'
              ? 'warning'
              : params.value === 'Terminate' || params.value === 'deactivated' || params.value === 'Blocked'
              ? 'error'
              : params.value === 'To be replaced' || params.value === 'Replaced'
              ? 'info'
              : 'default'
          }
          size="small"
        />
      )
    },
    // {
    //   field: 'view',
    //   headerName: 'View',
    //   sortable: false,
    //   width: 80,
    //   headerAlign: 'center',
    //   align: 'center',
    //   renderCell: (params) => <Button size='small' onClick={() => props.handleView(params.row)} endIcon={<VscEye />}>view</Button>
    // },
    {
      field: 'action',
      headerName: 'Action',
      sortable: false,
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <ButtonGroup>
          <Button
            size="small"
            onClick={() => props?.handleView(params.row)}
            sx={{
              borderColor: '#592375',
              color: '#592375',
              borderRadius: '6px',
              '&:hover': {
                borderColor: '#592375'
              }
            }}
            endIcon={<VscEye />}
          >
            view
          </Button>
          <Button
            size="small"
            onClick={() => handleStatusOpen(params.row)}
            sx={{
              borderColor: '#592375',
              color: '#592375',
              borderRadius: '6px',
              '&:hover': {
                borderColor: '#592375'
              }
            }}
            endIcon={<EditOutlinedIcon />}
          >
            Edit
          </Button>
        </ButtonGroup>
      )
    }
  ];

  return (
    <Paper sx={{ height: 400, width: '100%' }}>
      <StatusDialog open={OpenStatus} handleClose={handleStatusClose} Userid={UserIdData} refunction={props?.refunction} />
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(rows) => rows.user_id}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
              page: 0
            }
          }
        }}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            color: '#592375'
          }
        }}
        onPaginationModelChange={(paginationModel) => {
          props?.setPage(paginationModel?.page); // Update the current page
          props?.setRowsPerPage(paginationModel?.pageSize); // Update the rows per page
        }}
        loading={props?.Isloading}
        autoHeight
        disableRowSelectionOnClick
      />
    </Paper>
  );
}
